<template>
  <div>
    <template v-if="data.type.indexOf('range') != -1">
      <el-form-item label="开始占位内容">
        <el-input v-model="data.startPlaceholder" placeholder="开始占位内容"></el-input>
      </el-form-item>
      <el-form-item label="结束占位内容">
        <el-input v-model="data.endPlaceholder" placeholder="结束占位内容"></el-input>
      </el-form-item>
    </template>
    <el-form-item label="占位内容" v-else>
      <el-input v-model="data.placeholder" placeholder="占位内容"></el-input>
    </el-form-item>
    <!-- <el-form-item label="默认值">
      <el-input v-model="data.valueDefault"
                placeholder="默认值"></el-input>
    </el-form-item> -->
    <el-form-item label="默认值">
      <el-tooltip class="item" effect="dark" placement="top-start">
        <div slot="content">
          <TipContent :dataType="data.type" />
        </div>
        <el-input v-model="data.value" placeholder="默认值"></el-input>
      </el-tooltip>
    </el-form-item>

    <template v-if="data.type !== 'timerange'">

      <el-form-item label="显示模式" v-if="data.type === 'time'">
        <el-radio v-model="data.mode" label="1" style="marginRight: 5px;">1列</el-radio>
        <el-radio v-model="data.mode" label="2" style="marginRight: 0;">2列</el-radio>
      </el-form-item>

      <div v-if="data.mode !== '2'">
        <el-form-item label="最小值">
          <el-tooltip class="item" effect="dark" placement="top-start">
            <div slot="content">
              <TipContent :dataType="data.type" />
            </div>
            <el-input v-model="data.minDate" placeholder="最小值"></el-input>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="最大值">
          <el-tooltip class="item" effect="dark" placement="top-start">
            <div slot="content">
              <TipContent :dataType="data.type" />
            </div>
            <el-input v-model="data.maxDate" placeholder="最大值"></el-input>
          </el-tooltip>
        </el-form-item>
      </div>

    </template>
    <div v-if="data.mode !== '2'">
      <div v-if="['time'].includes(data.type)">
        <el-form-item label="起始时间">
          <el-input v-model="data.start" placeholder="起始时间" />
        </el-form-item>
        <el-form-item label="结束时间">
          <el-input v-model="data.end" placeholder="结束时间" />
        </el-form-item>
        <el-form-item label="步长">
          <el-input v-model="data.step" placeholder="步长(00:30)" />
        </el-form-item>
      </div>
    </div>

    <el-form-item label="显示格式化" style="marginTop: 20px">
      <el-input v-model="data.format" placeholder="显示格式化"></el-input>
    </el-form-item>
    <el-form-item label="值格式化">
      <el-input v-model="data.valueFormat" placeholder="值格式化"></el-input>
    </el-form-item>
    <el-form-item label="联动URL" label-width="100px" label-position="left">
      <el-input v-model="data.casUrl"></el-input>
    </el-form-item>
    <!-- 扩展 字段采集 开始 -->
    <el-form-item label="采集资源" v-if="!isDynamic && data.type.indexOf('range') < 0">
      <el-select clearable v-model="data.resourceId" placeholder="请选择采集资源：">
        <el-option v-for="item in resource" :key="item.resourceId" :label="item.tableComment" :value="item.resourceId">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="采集字段" v-if="data.type.indexOf('range') < 0">
      <el-select clearable v-model="data.fieldName" placeholder="请选择采集字段">
        <el-option v-for="item in field" :key="item.columnName" :label="item.columnComment" :value="item.columnName">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="是否禁用">
      <el-switch v-model="data.disabled"></el-switch>
    </el-form-item>
    <el-form-item label="是否可见">
      <el-switch v-model="data.display"></el-switch>
    </el-form-item>
    <el-form-item label="列隐藏" v-if="isDynamic">
      <el-switch v-model="data.hide"></el-switch>
    </el-form-item>
    <el-form-item label="是否必填">
      <el-switch v-model="data.required"></el-switch>
    </el-form-item>

  </div>
</template>

<script>

export default {
  name: 'ConfigDate',
  props: ['data', 'widgetForm'],
  data() {
    return {
      resource: [],
      field: [],
      validator: {
        type: null,
        required: null,
        pattern: null,
        length: null
      },
      activeNames: ['1']
    }
  },
  computed: {
    // 判断
    isDynamic: function () {
      let dynamicArray = this.widgetForm.column.filter(item => item.type === 'dynamic')
      if (dynamicArray.length === 0) {
        return false
      } else {
        for (let i = 0; i < dynamicArray.length; i++) {
          let itemArray = dynamicArray[i].children.column.filter(item => item === this.data)
          if (itemArray.length === 1) {
            if (dynamicArray[i].resourceId) {
              this.data.resourceId = dynamicArray[i].resourceId
              this.resourceIdChange(dynamicArray[i].resourceId)
            }
            return true
          }
        }
        return false
      }
    }
  },
  mounted() {
    if (!this.isDynamic) {
      // 加载字典
      this.getResource()
      // 如果所选字段有值,常饿一次
      if (this.data.resourceId) {
        this.resourceIdChange(this.data.resourceId)
      }
    }
  },
  components: {
    TipContent: () => import('./TipContent')
  },
  methods: {
    /** 获得配置资源 */
    getResource() {
      this.$http.post('/data-collection-resourece/table-or-view-query', { entity: {} }, {
        params: {
          pageNum: 1,
          pageSize: 999
        }
      }).then(response => {
        this.resource = response.data.records.map(item => ({ tableComment: item.tableComment, resourceId: item.id }))
      }).catch(error => this.$message.error(error.msg || error.message))
    },
    // resourceId 改变加载可选字段
    resourceIdChange(resourceId) {
      if (resourceId) {
        this.$http.get('/data-collection-resourece/field-query', {
          params: {
            resourceId
          }
        }).then(response => {
          this.field = response.data
        }).catch(error => this.$message.error(error.msg || error.message))
      } else {
        this.data.fieldName = ''
        this.field = []
      }
    },
    generateRule() {
      const rules = []
      Object.keys(this.validator).forEach(key => {
        if (this.validator[key]) rules.push(this.validator[key])
      })
      this.data.rules = rules
    }
  },
  watch: {
    'data.resourceId': function (val) {
      if (val) {
        this.resourceIdChange(val)
      }
    },
    'data.required': function (val) {
      if (val) this.validator.required = { required: true, message: `${this.data.label}必须填写` }
      else this.validator.required = null

      this.generateRule()
    }
  }
}
</script>

<style lang='scss' scoped>
:deep(.el-collapse-item__content) {
  padding-bottom: 0px;
}
</style>
